export class LegTypeCode {
  static Win = 'W'
  static Place = 'P'
  static WinPlace = 'WP'
}
